import modals from '../components/modals';
import Swiper, {
	Navigation,
	Pagination,
} from 'swiper';

const popupSliders = [];
let cards = [];

Swiper.use([Navigation, Pagination]);

const likesBtnsActive = [];

function getActiveLikes() {
	// eslint-disable-next-line no-useless-concat
	const cookie = decodeURIComponent(document.cookie.match(new RegExp('yourvoice2' + '=([^;]+)')));

	const cookieSplit = cookie.split(',')[1];

	if (cookieSplit) {
		cookieSplit.split('~').forEach((el) => {
			likesBtnsActive.push(el.split('.')[1]);
		});
	}
}

function resetStatusPopupSliders() {
	popupSliders.forEach((item) => {
		item.setProgress(0, 0);
		item.update();
	});
}

function stopProps(array) {
	array.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.stopPropagation();
		});
	});
}

function changeLike(likes, response) {
	likes.forEach((item) => {
		item.classList.add('heroes__likes--active');
		item.querySelector('.like-num').innerText = response[1];

		// if (response[0] !== '7') {
		// 	item.classList.add('heroes__likes--active');
		// 	item.querySelector('.like-num').innerText = response[1];
		// } else {
		// 	const counter = Number(item.querySelector('.like-num').innerText) - 1;
		// 	item.classList.remove('heroes__likes--active');
		// 	item.querySelector('.like-num').innerText = counter;
		// }
	});
}

function initLikes() {
	let cardList = document.querySelectorAll('.heroes__item');

	cardList.forEach((card) => {
		const cardName = card.closest('a[data-modal-id]').getAttribute('data-modal-id');
		const cardModal = document.querySelector(`[data-remodal-id="${cardName}"]`);
		const cardLike = card.querySelector('.js-like');
		const modalLikes = cardModal.querySelectorAll('.js-like');
		let num = cardLike.querySelector('.like-num').textContent;

		cards.push({
			el: card,
			name: cardName,
			like: cardLike,
			modal: cardModal,
			cardModalLikes: modalLikes,
			likeState: num,
		});

		modalLikes.forEach((item) => {
			item.querySelector('.like-num').innerText = num;
		});
	});
}

function initModelSwiper() {
	const buildSlider = (sliderEl) => {
		const sliderId = sliderEl.dataset.id;

		const slider = new Swiper(`.swiper--${sliderId}-${sliderId}`, {
			direction: 'horizontal',
			slidesPerView: 1,
			spaceBetween: 100,
			speed: 400,
			autoHeight: true,
			loop: false,
			centeredSlides: true,
			navigation: {
				nextEl: `.swiper-button-next--${sliderId}-${sliderId}`,
				prevEl: `.swiper-button-prev--${sliderId}-${sliderId}`,
				disabledClass: 'swiper-button--disabled',
			},
			pagination: {
				el: `.remodal .swiper-pagination--${sliderId}-${sliderId}`,
				type: 'bullets',
				clickable: true,
			},
		});

		popupSliders.push(slider);

		return slider;
	};

	const heroesSliders = document.querySelectorAll('.remodal .swiper');
	heroesSliders.forEach((slider) => buildSlider(slider));
}

function initSwiper() {
	const buildSlider = (sliderEl) => {
		const sliderId = sliderEl.dataset.id;

		return new Swiper(`.swiper--${sliderId}`, {
			direction: 'horizontal',
			spaceBetween: 100,
			speed: 400,
			autoHeight: false,
			loop: false,
			navigation: {
				nextEl: `.heroes .swiper-button-next--${sliderId}`,
				prevEl: `.heroes .swiper-button-prev--${sliderId}`,
				disabledClass: 'swiper-button--disabled',
			},
		});
	};

	const heroesSliders = document.querySelectorAll('.heroes .swiper');
	heroesSliders.forEach((slider) => buildSlider(slider));

	stopProps(document.querySelectorAll('.heroes .swiper-button-next, .heroes .swiper-button-prev'));
}

function heroesAjax(e, number, operation, token) {
	const request = new XMLHttpRequest();
	const url = 'ajax/ajax.php';
	const params = `number=${number}&operation=${operation}&token=${token}`;

	request.open('POST', url, false); // false - синхронный, true - асинхронный
	request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	request.addEventListener('readystatechange', () => {
		if (request.readyState === 4 && request.status === 200) {
			const retAjax = request.responseText.split('.');

			if (operation !== '') {
				const dependentLikes = document.querySelectorAll(`[data-card-id="${number}"]`);
				changeLike(dependentLikes, retAjax);
			} else {
				const dependentLikes = document.querySelectorAll(`[data-card-id="${number}"]`);
				changeLike(dependentLikes, retAjax);
			}

			return retAjax[1];
		}

		return 0;
	});

	request.send(params);
}

function initLikes2() {
	let likesBtns = document.querySelectorAll('.js-like');
	let StopDate = new Date('5/1/23'); // Дата окончания голосования

	if (Date.now() > Date.parse(StopDate)) {
		// eslint-disable-next-line no-alert
		alert('Голосование закончено!');

		return; // Прерываем  голосование
	}

	likesBtns.forEach((item) => {
		if (likesBtnsActive.includes(item.getAttribute('data-card-id'))) {
			item.classList.add('heroes__likes--active');
		}

		item.addEventListener('click', (e) => {
			e.stopPropagation();

			const cardNumber = e.currentTarget.getAttribute('data-card-id');
			const active = e.currentTarget.classList.contains('heroes__likes--active');

			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise.execute('6LcAZbslAAAAAPnFubm6u917lStOVGbIk01zLSE0', {action: 'login'}).then((token) => {
					if (!active) {
						heroesAjax(e, cardNumber, '', token);
					}
				});
			});
		});
	});
}

function heroesAjaxJson() {
	const request = new XMLHttpRequest();
	const url = 'ajax/ajax.php?operation';
	// const url = 'https://kp-nashi-lyudi.linestest.com/ajax/ajax.php?operation';

	request.open('POST', url, false); // false - синхронный, true - асинхронный
	request.setRequestHeader('Content-type', 'application/json');
	request.addEventListener('readystatechange', () => {
		if (request.readyState === 4 && request.status === 200) {
			// {"5":3,"1":1,....}
			let data = JSON.parse(request.response);

			data[0].forEach((el, index) => {
				const card = document.querySelector(`[data-modal-id="${el}"]`);

				if (card) {
					const num = card.querySelector('.like-num');
					num.innerText = data[1][index];
				}
			});
		}

		initLikes();
		getActiveLikes();
		initSwiper();
		initModelSwiper();
		modals.init();

		return 0;
	});

	request.send();
}

function init() {
	if (document.querySelector('.votes')) {
		heroesAjaxJson();
		initLikes2();
	}
}

export default {
	init,
	resetStatusPopupSliders,
};
